import axios from "axios";

const sendRequest = args => {
  let token = localStorage["token"];
  if (token) token = JSON.parse(token);
  return axios({
    headers: {
      Authorization: `Bearer ${token}`
    },
    ...args
  });
};

export default sendRequest;
